module.exports = __webpack_public_path__ + "static/media/ecommerceLogo.7587ece2.png";